import { useUserLevelList } from "../../../../context/UserLevelListContext";
import styles from "./style.module.scss";

const VIPIconContainer = ({ vipLevel = "VIP0", imageStyle = "" }) => {
  const { levelListLength } = useUserLevelList();

  return (
    <img
      className={`${styles.image} ${imageStyle}`}
      src={`/images/vip/secondVersion/smallIcon/level${levelListLength}/${vipLevel}_S.png`}
      alt={vipLevel}
    />
  );
};
export default VIPIconContainer;
